/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { ChangeLearningOpportunityValues } from './changeLearningOpportunityModal.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'change-learning-opportunity-modal',
    standalone: false,
})
export class ChangeLearningOpportunityModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Output() dismiss: EventEmitter<void>;
    @Input() resolve: ChangeLearningOpportunityValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('changeLearningOpportunityModal', elementRef, injector);
    }
}
